import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourInicio: TourDefinicion = {
  codigo: 'inicio',
  titulo: 'Inicio',
  descripcion: 'Bienvenida y orientación sobre tus accesos en el dashboard.',
  ruta: '/admin/inicio',
  pasos: [
    {
      id: 'inicio:header',
      selector: '[data-testid="inicio.header"]',
      titulo: 'Bienvenido al portal APEPS',
      descripcion:
        'Este es tu espacio de trabajo. Desde aquí accedes a todos los módulos para los que tu rol tiene permisos.',
      side: 'bottom',
      align: 'center',
    },
    {
      id: 'inicio:modulos',
      selector: '[data-testid="inicio.modulos"]',
      titulo: 'Tus accesos',
      descripcion:
        'Cada tarjeta está agrupada por módulo. Haz clic en cualquiera para ir directo a esa sección.',
      side: 'top',
      align: 'center',
    },
    {
      id: 'inicio:ayuda',
      selector: '[data-testid="navbar.user-menu"]',
      titulo: '¿Necesitas ayuda?',
      descripcion:
        'En cada pantalla encontrarás un ícono ? para volver a ver la guía del menú. También puedes abrirlas desde aquí, en el menú de tu usuario.',
      side: 'bottom',
      align: 'end',
    },
  ],
};
